const en_master_customer = {
    add: "add customer",
    address: "customer address",
    edit: "edit customer",
    email: "customer email",
    name: "customer name",
    phone: "customer phone",
    upload: "upload customer",

    form: {
        ppn_label: "Enable to use PPN",
        upload_title: "input customer data",
        coa: "credit COA",
    },

    message: {
        note_upload: "NOTE: Only Excel file formats can be uploaded!",
        note_excel: "Download the customer Excel template",
        note_term_title: "File Requirements:",
        note_term_1: "Use the provided template.",
        note_term_2: "Fields marked with '*' are required",
        note_term_3: "Customer Name: This field is required. Customers that already exist in the database cannot be added again. Example: customer1, customer2, customer3.",
        note_term_4: "Enter 1 in the PPN column to apply PPN, or 0 if PPN is not applicable.",
    },

    error: {
        create: "Failed to create customer.",
        delete: "Failed to delete customer.",
        edit: "Failed to update customer.",
    },

    success: {
        create: "Customer created successfully.",
        delete: "Customer deleted successfully.",
        edit: "Customer updated successfully.",
    }
}

export default en_master_customer;